import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store'
//Main views
import Home from '@/views/home/Home';
import Authentication from '@/views/authentication/Authentication';
//Authentication
import ExpiredPassword from '@/views/authentication/ExpiredPassword';
import ForgetPassword from '@/views/authentication/ForgetPassword';
import ResetPassword from '@/views/authentication/ResetPassword';
import SignIn from '@/views/authentication/SignIn';
//Error HTTP  views
import UnauthorizedError from '@/views/error/401';
import NotFoundError from '@/views/error/404';
import ExpiredPwdMessage from '@/views/authentication/ExpiredPwdMessage';
import ForgetPwdMessage from '@/views/authentication/ForgetPwdMessage';
import SessionExpiredMessage from '@/views/authentication/SessionExpiredMessage';
//Test views
import Feeds from '@/views/home/Feeds';
//Perfiles
import Perfil from '@/views/seguridad/perfil/Perfil';
//Plantilla Correo
import PlantillaCorreo from '@/views/generales/plantillaCorreo/PlantillaCorreo';
//Usuario
import Usuario from '@/views/seguridad/usuario/Usuario';
//Parametros
import Parametros from '@/views/generales/parametros/Parametros';
//Bitacora
import Bitacora from '@/views/bitacoras/bitacora/Bitacora';
//Reporte Auditoria
import ReporteAuditoria from '@/views/bitacoras/reporteAuditoria/ReporteAuditoria';
//Perfil Usuario
import PerfilUsuario from '@/views/seguridad/perfilUsuario/PerfilUsuario';
//MonitorCorreos
import MonitorCorreos from '@/views/bitacoras/monitorCorreos/MonitorCorreos';
//Comercio
import Comercio from '@/views/generales/comercio/Comercio';
//Bitacora Documento
import BitacoraArchivo from '@/views/bitacoras/documento/BitacoraArchivo';
//Seguimiento y Control Scheduled
import SeguimientoControlScheduled from '@/views/seguimiento/scheduled/SeguimientoControlScheduled';


Vue.use(Router);

const isNotAuthenticated= (to,from,next)=>{
  if(!store.getters.getUserIsAuthenticated){
    next()
    return
  }
  next('/home')
}

const isAuthenticated= (to,from,next)=>{
  if(store.getters.getUserIsAuthenticated)
  {
    next()
    return
  }
  next('/auth')
}

export default new Router({
  mode: 'history'
  , routes: [
    {
      path: ''
      , redirect: '/auth'
    }
    , {
      path: '/auth'
      //, name: 'Authentication'
      , component: Authentication
      , beforeEnter: isNotAuthenticated
      , children:[
        {
          path: ''
          , name: 'SignIn'
          , component: SignIn
        }
        , {
          path: 'expiredpwd'
          , name: 'ExpiredPassword'
          , component: ExpiredPassword
        }
        , {
          path: 'forgetpwd'
          , name: 'ForgetPassword'
          , component: ForgetPassword
        }
        , {
          path: 'resetpwd'
          , name: 'ResetPassword'
          , component: ResetPassword
        }
      ]
    }
    , {
      path: '/sessionexpiredmessage'
      , name: 'SessionExpiredMessage'
      , component: SessionExpiredMessage
    }
    , {
      path: '/expiredpwdmessage'
      , name: 'ExpiredPwdMessage'
      , component: ExpiredPwdMessage
    }
    , {
      path: '/forgetpwdmessage'
      , name: 'ForgetPwdMessage'
      , component: ForgetPwdMessage
    }

    , {
      path: '/404NotFound'
      , name: 'PageNotFound'
      , component: NotFoundError
    }
    , {
      path: '/401Unauthorized'
      , name: '401Unauthorized'
      , component: UnauthorizedError
    }
    , {
      path: '/home'
      //, name: 'Home'
      , component: Home
      , beforeEnter: isAuthenticated
      , children:[
        {
          path: ''
          , name: 'Feeds'
          , component: Feeds
          , meta:{
            permissions: [
              {
                role: "ROLE_ACCESO_AFC",
                access: true,
                redirect: "401Unauthorized"
              }
            ]
          }
        }
        , {
          path: 'perfiles'
          , name: 'Perfil'
          , component: Perfil
          , meta:{
            bitacora: 'Groups'
            , breadcrumb:'Perfiles'
            , permissions: [
              {
                role: "ROLE_ACCESO_SEGURIDAD",
                access: true,
                redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: 'plantillaCorreo'
          , name: 'PlantillaCorreo'
          , component: PlantillaCorreo
          , meta:{
            bitacora: 'TPlantillaCorreo'
            , breadcrumb:'Plantilla Correo'
            , permissions: [
              {
                role: "ROLE_ACCESO_CATALOGOS",
                access: true,
                redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: 'usuario'
          , name: 'Usuario'
          , component: Usuario
          , meta:{
            bitacora: 'Users'
            , breadcrumb:'Usuarios'
            , permissions: [
              {
                role: "ROLE_ACCESO_SEGURIDAD",
                access: true,
                redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: 'parametros'
          , name: 'Parametros'
          , component: Parametros
          , meta:{
            bitacora: 'TParametros'
            , breadcrumb:'Párametros'
            , permissions: [
              {
                role: "ROLE_ACCESO_PARAMETROS",
                access: true,
                redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: 'bitacora'
          , name: 'Bitacora'
          , component: Bitacora
          , meta:{
            bitacora: 'TBitacora'
            , breadcrumb:'Bitácora de Acceso'
            , permissions: [
              {
                role: "ROLE_ACCESO_BITACORA",
                access: true,
                redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: 'reporteAuditoria'
          , name: 'ReporteAuditoria'
          , component: ReporteAuditoria
          , meta:{
            bitacora: 'ReporteAuditoriaDTO'
            , breadcrumb:'Reportes Auditoría'
            , permissions: [
              {
                role: "ROLE_ACCESO_REPORTES_AUDITORIA",
                access: true,
                redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: 'monitorNotificaciones'
          , name: 'MonitorCorreos'
          , component: MonitorCorreos
          , meta:{
            bitacora: 'TCorreo'
            , breadcrumb:'Monitor de notificaciones'
            , permissions: [
              {
                role: "ROLE_ACCESO_BITACORA",
                access: true,
                redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: 'perfilUsuario'
          , name: 'PerfilUsuario'
          , component: PerfilUsuario
          , meta:{
            bitacora: 'PerfilUsuarioDTO'
            , breadcrumb:'Perfil Usuario'
            , permissions: [
              {
                role: "ROLE_ACCESO_AFC",
                access: true,
                redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: 'comercio'
          , name: 'Comercio'
          , component: Comercio
          , meta:{
            bitacora: 'TComercio'
            , breadcrumb:'Comercios'
            , permissions: [
              {
                role: "ROLE_ACCESO_COMERCIO",
                access: true,
                redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: 'bitacoraArchivo'
          , name: 'BitacoraArchivo'
          , component:BitacoraArchivo
          , meta:{
            bitacora: 'TArchivo'
            , breadcrumb:'Bitácora de Archivos'
            , permissions: [
              {
                role: "ROLE_ACCESO_BITACORA_ARCHIVOS",
                access: true,
                redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: 'seguimientoScheduled'
          , name: 'SeguimientoControlScheduled'
          , component:SeguimientoControlScheduled
          , meta:{
            bitacora: 'TBitacoraScheduler'
            , breadcrumb:'Procesos'
            , permissions: [
              {
                role: "ROLE_ACCESO_PROCESOS",
                access: true,
                redirect: "Feeds"
              }
            ]
          }
        }
      ]
      , meta:{
        breadcrumb:'Inicio'
        , permissions: [
          {
            role: "ROLE_ACCESO_AFC",
            access: true,
            redirect: "401Unauthorized"
          }
        ]
      }
    }
    , {
			path: '/*'
			, name: 'pageNotFound'
			, component: NotFoundError
		}
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js